import React from 'react';
import { Alert } from '@mui/material';
import ActionRequiredTab from '../../ActionRequiredTab';
import AppSheetAccountsMissingBac from '../../AppSheetAccountsMissingBac';
import AppSheetStatusChangesReport from '../../AppSheetStatusChangesReport';
import AppSheetUnmatchedProducts from '../../AppSheetUnmatchedProducts';
import CancelsReport from '../../CancelsReport';
import EmailsSentReport from '../../EmailsSentReport';
import HistoricalTrends from '../../HistoricalTrends';
import SendHistoryMRT from '../../SendHistoryMRT';
import StatusChangesTab from '../../StatusChangesTab';
import AppSheetTableWidget from './AppSheetTableWidget';

const noop = () => {};

const renderLegacyReport = (reportKey) => {
  switch (reportKey) {
    case 'status_changes':
      return (
        <StatusChangesTab
          onNavigateToDealer={noop}
          onOpenDetail={noop}
          userEmail={null}
          isMaximized={false}
          onToggleMaximize={noop}
        />
      );
    case 'historical_trends':
      return <HistoricalTrends />;
    case 'send_history':
      return <SendHistoryMRT />;
    case 'emails_sent':
      return <EmailsSentReport />;
    case 'action_required':
      return <ActionRequiredTab onNavigateToDealer={noop} onOpenDetail={noop} />;
    case 'cancels':
      return <CancelsReport />;
    case 'appsheet_unmatched_products':
      return <AppSheetUnmatchedProducts />;
    case 'appsheet_accounts_missing_bac':
      return <AppSheetAccountsMissingBac />;
    case 'appsheet_status_changes':
      return <AppSheetStatusChangesReport />;
    case 'appsheet_live_pending_cancel_not_enrolled':
      return <></>;
    default:
      return null;
  }
};

const LegacyReportWidget = ({ widget }) => {
  if (!widget) return null;
  if (widget.type === 'appsheet_table') {
    return <AppSheetTableWidget widget={widget} />;
  }
  if (widget.type !== 'legacy_report') return null;

  const reportKey = widget.params?.reportKey;
  const rendered = renderLegacyReport(reportKey);
  if (!rendered) {
    return <Alert severity="warning">Unsupported legacy report: {reportKey}</Alert>;
  }
  return rendered;
};

export default LegacyReportWidget;
